// extracted by mini-css-extract-plugin
export default {"pendingValue":"LineItemShippingPendingMaybe_pendingValue__bDG8b"};